import React, { useMemo } from 'react';
import { ButtonCondensed } from '@companycam/slab-web';
import styled from 'styled-components';
import { translate } from 'translations/i18n';

const TranslateIcon = (
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="M8.58033 10.0468L6.88699 8.3735L6.90699 8.3535C8.06699 7.06016 8.89366 5.5735 9.38032 4.00016H11.3337V2.66683H6.66699V1.3335H5.33366V2.66683H0.666992V4.00016H8.11366C7.66699 5.28016 6.96033 6.50016 6.00033 7.56683C5.38033 6.88016 4.86699 6.12683 4.46033 5.3335H3.12699C3.61366 6.42016 4.28033 7.44683 5.11366 8.3735L1.72033 11.7202L2.66699 12.6668L6.00033 9.3335L8.07366 11.4068L8.58033 10.0468ZM12.3337 6.66683H11.0003L8.00033 14.6668H9.33366L10.0803 12.6668H13.247L14.0003 14.6668H15.3337L12.3337 6.66683ZM10.587 11.3335L11.667 8.44683L12.747 11.3335H10.587Z" />
  </svg>
);

const TranslateContainer = styled.div`
  margin-top: 8px;
`;

const CommentTranslateButton = ({
  handleTranslate,
  handleSeeOriginal,
  isTranslated,
  language,
  originalLanguage,
}: {
  handleTranslate: () => void;
  handleSeeOriginal: () => void;
  isTranslated: boolean;
  language: string;
  originalLanguage?: string[];
}) => {
  const canBeTranslated = useMemo(
    () =>
      originalLanguage &&
      originalLanguage.length > 0 &&
      originalLanguage?.some((lang) => lang !== language),
    [originalLanguage, language],
  );

  if (canBeTranslated) {
    return (
      <TranslateContainer>
        {!isTranslated ? (
          <ButtonCondensed
            color="primary"
            size="small"
            icon={{
              component: TranslateIcon,
              name: 'link',
              position: 'before',
            }}
            onClick={handleTranslate}
          >
            {translate('activity.commentTranslate.translate')}
          </ButtonCondensed>
        ) : (
          <ButtonCondensed
            color="primary"
            size="small"
            onClick={handleSeeOriginal}
          >
            {translate('activity.commentTranslate.seeOriginal')}
          </ButtonCondensed>
        )}
      </TranslateContainer>
    );
  }

  return null;
};

export default CommentTranslateButton;
